export const STATUS_TICKET_CONSTANT = Object.freeze({
    UNASSIGNED: "unassign",
    ASSIGNED: "assigned",
    IN_PROGRESS: "inprogress",
    ON_HOLD: "onhold",
    CLOSED: "close",
    RESOLVED: "resolved",
    UNDER_OBSERVATION: "underobservation"
});